import { useCallback, useEffect, useState } from 'react';
import { getInfracaoMotoristaPremiacoes } from '@spark/services/premiacao';
import { notification } from '@spark/ui-components/utils/notification';
import { toApiDate } from '@spark/utils/formatters';

const normalizeFilters = (filtros) => (
  Object.fromEntries(
    Object.entries(filtros)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => [key, value instanceof Date ? toApiDate(value) : value])
  )
);

export const usePremiacaoInfracaoMotoristaSelection = (show, idInfracao) => {
  const [motoristas, setMotoristas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtros, setFiltros] = useState({});
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [quantidadePorPagina, setQuantidadePorPagina] = useState(10);
  const [totalRegistros, setTotalRegistros] = useState(0);

  const carregarMotoristas = useCallback(async () => {
    if (!show) return;

    try {
      setLoading(true);
      const params = {
        PaginaAtual: paginaAtual,
        QuantidadePorPagina: quantidadePorPagina,
        ...normalizeFilters(filtros)
      };

      if (idInfracao) {
        params.IdInfracao = idInfracao;
      }

      const response = await getInfracaoMotoristaPremiacoes(params);
      const data = response?.data || response || {};
      const registros = Array.isArray(data.registros) ? data.registros : [];

      setMotoristas(registros);
      setTotalRegistros(data.totalRegistros || registros.length);
    } catch (error) {
      console.error('Erro ao carregar infracoes de motorista:', error);
      notification.error(
        error?.message || 'Nao foi possivel carregar as infracoes de motorista',
        'Erro ao carregar motoristas'
      );
      setMotoristas([]);
      setTotalRegistros(0);
    } finally {
      setLoading(false);
    }
  }, [show, idInfracao, filtros, paginaAtual, quantidadePorPagina]);

  useEffect(() => {
    if (show) {
      carregarMotoristas();
    }
  }, [show, carregarMotoristas]);

  useEffect(() => {
    if (show) {
      setPaginaAtual(1);
    }
  }, [idInfracao, show]);

  const handleFiltrosChange = useCallback((novosFiltros) => {
    setFiltros(novosFiltros);
    setPaginaAtual(1);
  }, []);

  const handlePaginationChange = useCallback((paginationState) => {
    if (paginationState.pageSize !== quantidadePorPagina) {
      setQuantidadePorPagina(paginationState.pageSize);
      setPaginaAtual(1);
    } else if (paginationState.pageIndex !== undefined) {
      setPaginaAtual(paginationState.pageIndex + 1);
    }
  }, [quantidadePorPagina]);

  const resetFiltros = useCallback(() => {
    setFiltros({});
    setPaginaAtual(1);
    setQuantidadePorPagina(10);
  }, []);

  const reload = useCallback(() => {
    carregarMotoristas();
  }, [carregarMotoristas]);

  return {
    motoristas,
    loading,
    filtros,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
    resetFiltros,
    reload
  };
};
